export default "__VITE_ASSET__EkmS$mV7__"